// extracted by mini-css-extract-plugin
export default {"arrow":"CarouselArrow_arrow__SHCcF","prev":"CarouselArrow_prev__QcuWF","next":"CarouselArrow_next__QJWwR"};